import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FormattedMessage, FormattedHTMLMessage, injectIntl, intlShape } from 'react-intl';
import { reduxForm, FormSection, getFormSyncErrors, Form, change, submit } from 'redux-form';
import _ from 'lodash';
import { FLOW_TYPE, CREDIT_TYPE, COUNTRY, FORM_ID } from '../../../../../framework/App/AppConstants';
import { trackTransition } from '../../../../../framework/store/FPTI/FPTIActions';
import PopupLink from '../../../../../shared-components/PopupLink/PopupLink';
import { getInitialFormValues } from '../../../../config/form';

import ToolTip from '../../../../../shared-components/ToolTip/ToolTip';
import { submitApplicationApi } from './ApplyPageFormActions';
import { spinnerOpen } from '../../../../../framework/components/FullPageSpinner/FullPageSpinnerActions';
import IBAN from '../../../../components/IBAN/IBAN';
import UserTitle from '../../../../components/UserTitle/UserTitle';
import DOB from '../../../../components/DateOfBirth/DateOfBirth';

import FirstName from '../../../../../shared-components/NameComponent/FirstName/FirstName';
import LastName from '../../../../../shared-components/NameComponent/LastName/LastName';
import Street1 from '../../../../../shared-components/AddressComponent/Street1/Street1';
import City from '../../../../../shared-components/AddressComponent/City/City';
import PostalCode from '../../../../../shared-components/AddressComponent/PostalCode/PostalCode';

import Email from '../../../../../shared-components/Email/Email';
import PhoneType from '../../../../components/PhoneGroup/PhoneType/PhoneType';
import PhoneNumber from '../../../../components/PhoneGroup/PhoneNumber/PhoneNumber';
import Col from '../../../../../shared-components/VXGrid/Col';
import Row from '../../../../../shared-components/VXGrid/Row';
import SEPACheckBox from '../../../../components/AgreeToSEPACheckBox/AgreeToSEPACheckBox';
import {PRIVACY_POLICY_URL, CREDIT_CHECK_URL} from '../../../../config/DEConstants';
import './ApplyPageForm.less';
import Button, {BUTTON_STYLE} from '../../../../../shared-components/Button/Button';

const LOCALE_PREFIX = 'DE/pages/ApplyPage/ApplyPage';
const LOCALE_PREFIX_FIRSTNAME = 'DE/components/FirstName/FirstName';
const LOCALE_PREFIX_LASTNAME = 'DE/components/LastName/LastName';
const LOCALE_PREFIX_Address = 'DE/components/Address/Address';


export class ApplyPageForm extends Component {
    static propTypes = {
        flow: PropTypes.oneOf(Object.values(FLOW_TYPE)).isRequired,
        country: PropTypes.oneOf(Object.values(COUNTRY)).isRequired,
        formValues: PropTypes.object,
        formSyncErrors: PropTypes.object,
        currencySymbol: PropTypes.string,
        creditType: PropTypes.string,
        // Provided from decorated reduxForm() component
        handleSubmit: PropTypes.func.isRequired,
        financingDetails: PropTypes.shape({
            apr: PropTypes.number,
            term: PropTypes.number,
            monthly_payment: PropTypes.string,
            total_interest: PropTypes.string,
            total_cost: PropTypes.string,

        }),
        locale: PropTypes.string,
        cart: PropTypes.shape({
            gross_total_amount: PropTypes.shape({
                value: PropTypes.string
            })
        }),
        onClickApply: PropTypes.func.isRequired,
        onClickViewSepaMandate: PropTypes.func.isRequired,
        onFormSubmit: PropTypes.func.isRequired,

        // Comes from injectIntl HOC
        intl: intlShape.isRequired,

        // Comes from reduxForm HOC
        dirty: PropTypes.bool, // Has form been touched
        submitting: PropTypes.bool, // Redux inject this to indicate if the form submit is still in progress
        showCYCO: PropTypes.bool
    };

    constructor(props) {

        super(props);
    }
    render() {
        const { intl, dirty, onClickApply, handleSubmit, onClickViewSepaMandate, flow, country,
            financingDetails, onFormSubmit, locale, submitting, showCYCO} = this.props;
        const apr = _.get(financingDetails, 'apr', 0);
        const term = _.get(financingDetails, 'term');
        const monthly_payment = _.get(financingDetails, 'monthly_payment');
        const total_interest = _.get(financingDetails, 'total_interest');
        const total_cost = _.get(financingDetails, 'total_cost');
        const changeInstallmentUrl = showCYCO ? `/ppcreditapply/${flow}/${country}/cycopage` : `/ppcreditapply/${flow}/${country}/changeInstallment`;
        return (
            <div className="formWrapper">
                <Form
                    action="apply"
                    id="ApplyPageForm"
                    method="post"
                    className="proceed mainForm bmlApplyHappy"
                    onSubmit={handleSubmit(onFormSubmit)}
                >
                    <div className="paymentPlanInfo subContainer">
                        <div id="creditTypeContainer">
                            <p className="primary">
                                {
                                    <a data-automation-id="changeInstallment"
                                        id="changeInstallment" className="pull-right small"
                                        href={changeInstallmentUrl}
                                    >
                                        <FormattedMessage
                                            id={`${LOCALE_PREFIX}.changeInstallment`}
                                        />
                                    </a>
                                }
                                {
                                    <strong>
                                        <FormattedMessage
                                            id={`${LOCALE_PREFIX}.creditDetailsHeader`}
                                            values={{
                                                term,
                                                monthly_payment
                                            }}
                                        />
                                    </strong>
                                }
                            </p>
                            <p className="personalInfo secondary">
                                <FormattedMessage
                                    id={`${LOCALE_PREFIX}.creditDetails`}
                                    values={{
                                        total_cost,
                                        total_interest,
                                    }}
                                />
                            </p>
                        </div>
                    </div>

                    <FormSection name="bank-info">
                        <h2 className="alpha border-top">
                            <FormattedMessage id={`${LOCALE_PREFIX}.bmlApplyBankHeadLine`} />
                            <ToolTip
                                id="bmlApplyBankHeadLineToolTip"
                                text={intl.formatMessage({
                                    id: `${LOCALE_PREFIX}.bmlApplyBankHeadLineToolTip`
                                })}
                            />
                        </h2>
                        <p className="personalInfo secondary">
                            <FormattedMessage
                                id={`${LOCALE_PREFIX}.bmlApplyBankInfoheadline2`}
                            />
                        </p>
                        <IBAN />
                    </FormSection>
                    <FormSection name="dob-info" className="dobGroup fieldGroup clearfix">
                        <h2 className="alpha">
                            <FormattedMessage id={`${LOCALE_PREFIX}.bmlApplyDOBHeadLine`} />
                        </h2>
                        <DOB />
                    </FormSection>

                    <FormSection name="personal-info">
                        <h2 className="alpha border-top">
                            <FormattedMessage id={`${LOCALE_PREFIX}.bmlApplyPersonalInfoHeadLine`} />
                        </h2>
                        <p className="personalInfo secondary">
                            <FormattedMessage
                                id={`${LOCALE_PREFIX}.bmlApplyPersonalInfoHeadLine2`}
                            />
                        </p>

                        <Row gutterSize={10}>
                            <Col xs={3}>
                                <UserTitle />
                            </Col>
                            <Col xs={9} md={4}>
                                <FirstName localePrefix={LOCALE_PREFIX_FIRSTNAME} />
                            </Col>
                            <Col xs={12} md={5}>
                                <LastName localePrefix={LOCALE_PREFIX_LASTNAME} />
                            </Col>
                        </Row>
                        <Row gutterSize={10}>
                            <Col xs={12}>
                                <Street1 localePrefix={LOCALE_PREFIX_Address} />
                            </Col>
                        </Row>
                        <Row gutterSize={10}>
                            <Col xs={7}>
                                <PostalCode localePrefix={LOCALE_PREFIX_Address} country={country} />
                            </Col>
                            <Col xs={5}>
                                <City localePrefix={LOCALE_PREFIX_Address} validateCity={false} />
                            </Col>
                        </Row>
                        <Row gutterSize={10}>
                            <Col xs={12}>
                                <Email />
                            </Col>
                        </Row>
                        <Row gutterSize={10}>
                            <Col xs={6}>
                                <PhoneType />
                            </Col>
                            <Col xs={6}>
                                <PhoneNumber />
                            </Col>
                        </Row>
                    </FormSection>

                    <div className="bmlESign secondary">
                        <FormattedHTMLMessage
                            id={`${LOCALE_PREFIX}.bmlapply-esign-text-1`}
                        />&nbsp;
                        <PopupLink
                            url={`${PRIVACY_POLICY_URL}${locale}`}
                            className="popup accessible-link"
                            name="esign-consent"
                        >
                            <FormattedMessage
                                id={`${LOCALE_PREFIX}.bmlapply-esign-link-text-1`}
                            />
                        </PopupLink>&nbsp;
                        <FormattedMessage id={`${LOCALE_PREFIX}.bmlapply-esign-text-2`} />&nbsp;
                        <PopupLink
                            url={`${CREDIT_CHECK_URL}${locale}`}
                            className="popup accessible-link"
                            name="esign-consent"
                        >
                            <FormattedMessage
                                id={`${LOCALE_PREFIX}.bmlapply-esign-link-text-2`}
                            />
                        </PopupLink>
                        <FormattedMessage
                            id={`${LOCALE_PREFIX}.bmlapply-esign-link-text-3`}
                        />
                    </div>
                    <SEPACheckBox viewSepaMandate={onClickViewSepaMandate} />

                </Form>
                {/* Keep the submit button html outside of the form to help prevent autosaving values in browser */}
                <div className="continue-button-wrapper">
                    <Button
                        data-automation-id="continue"
                        className="bmlApplyContinue"
                        btnStyle={BUTTON_STYLE.PP_PRIMARY}
                        id="bmlApplyContinue"
                        onClick={onClickApply}
                        disabled={submitting}
                    >
                        {intl.formatMessage({id: `${LOCALE_PREFIX}.bmlApply`})}
                    </Button>
                </div>
            </div>

        );
    }
}

export const mapStateToProps = state => ({
    initialValues: getInitialFormValues(state),
    formValues: _.get(state, 'form.ppcreditapply.values'),
    formSyncErrors: getFormSyncErrors(FORM_ID)(state),
    flow: _.get(state, 'serverData.flow'),
    creditType: _.get(state, 'serverData.financingDetails.credit_type', ''),
    financingDetails: _.get(state, 'serverData.financingDetails', {}),
    currencySymbol: _.get(state, 'serverData.currencySymbol'),
    locale: _.get(state, 'serverData.locale.locale', 'de_DE'),
    country: _.get(state, 'serverData.country'),
    cart: _.get(state, 'serverData.cart', {}),
    showCYCO: _.get(state, 'serverData.showCYCO', false)
});

export const mapDispatchToProps = dispatch => ({
    async onClickApply() {
        await dispatch(change(FORM_ID, 'isViewSepaMandate', false));
        await dispatch(submit(FORM_ID));
    },

    async onClickViewSepaMandate() {
        await dispatch(change(FORM_ID, 'isViewSepaMandate', true));
        await dispatch(submit(FORM_ID));
    },

    // handleSubmit will call this function if field validation passes.
    // formValues are passed by handleSubmit per api specification
    onFormSubmit(formValues) {
        dispatch(trackTransition('apply_pp_credit_applypage', 'process_apply_pp_credit_applypage'));
        dispatch(spinnerOpen());
        return dispatch(submitApplicationApi(formValues, LOCALE_PREFIX));
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(
    reduxForm({
        form: FORM_ID,
        destroyOnUnmount: false,
        forceUnregisteredOnUnmount: true
    })(ApplyPageForm)
));
